export default "__VITE_ASSET__DKw2qPI2__"